import styled from "styled-components";

import { RadioButton } from "@similarweb/ui-components";

export const StyledRadioGroupItem = styled(RadioButton)`
    padding: 0;

    label {
        margin-left: 4px;
    }
`;
